module.exports = __webpack_public_path__ + "img/CITIBANK.11e87eb8.svg";